import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import{ auth } from "firebase/app"
import { from, Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  user: Observable<firebase.User>

  userId: string = ''

  userEmail: string = ''

  mailchecked: boolean =false

  openSesstion:boolean = false

  constructor(private afAuth: AngularFireAuth, private fs:AngularFirestore,private router:Router) {

    this.user = afAuth.user
   
  }


  checkMail(email) {
    
    this.openSesstion = true
    
    var actionCodeSettings = {
    
      url: 'https://elmenu-87402.firebaseapp.com',
    
      handleCodeInApp: true

   }

   return this.afAuth.sendSignInLinkToEmail(email,actionCodeSettings)
   .then( () => {    
  
      this.router.navigate(["/check-mail"])
  
    })
    .catch(error => {
  
      console.log(error)
  
  });
}

  passUserData(email:string,
               password:string,
               date:string,
               tableno:number)
  {
   return this.fs.collection('passUserData').add({
     email,
     password,
     date,
     tableno
   }) 
  }
  
  getUserData() {
    return this.fs.collection('passUserData').valueChanges()
  }

  getUserDataId() {
    return this.fs.collection('passUserData', ref => ref.orderBy('date','desc').limit(1)).snapshotChanges()
  }

  deletUserDataPass(id) {
    return this.fs.doc(`passUserData/${id}`).delete()
  }

  siginup(email,password){
    return this.afAuth.createUserWithEmailAndPassword(email,password)
  }

  login(email,password) {
    return this.afAuth.signInWithEmailAndPassword(email,password)
  }
  logout() {
    return this.afAuth.signOut()
  }
}
